import React from "react";
import Skills from "../skills/Skills";

const resumeContent = [
  {
    jobPosition: `Owner`,
    jobType: `Phoenix, AZ`,
    jobDuration: `Sep 2023 - Present`,
    timeDuraton: `Part Time`,
    compnayName: "Lead Giants",
    jobDescription: ` At Lead Giants, we understand the crucial role outstanding customer support 
    plays in building strong customer relationships and driving business success. 
    With our team of highly skilled professionals, state-of-the-art technology, and commitment to 
    excellence, we are your trusted partner in delivering exceptional customer service, online marketing 
    and website development.`,
  },
  {
    jobPosition: `Web/App Developer`,
    jobType: `Finnovant | Remote`,
    jobDuration: `Jan 2021 - Jun 2022`,
    timeDuraton: `Full Time`,
    compnayName: "Finnovant Inc",
    jobDescription: ` I started off as a sales consultant with Finnovant.com, a technology based startup, 
    headquartered in Mountain View, CA. I provided call center services, built websites and customized mobile apps.`,
  },
  {
    jobPosition: `Owner`,
    jobType: `Virp Media | Remote`,
    jobDuration: `Jan 2020 - Nov 2020`,
    timeDuraton: `Full Time`,
    compnayName: "Virp Media",
    jobDescription: ` This was my third business startup. It was a call center based in the Philippines. 
    I had 35+ agents making calls for different client campaigns.`,
  },
];

const educatonContent = [
  {
    passingYear: "2022-2023",
    degreeTitle: "Web Design",
    instituteName: "Phoenix Computer Academy",
  },
  {
    passingYear: "2018-2019",
    degreeTitle: "C# Full Stack Development",
    instituteName: "Claim Academy",
  },
  {
    passingYear: "2013-2015",
    degreeTitle: "General Studies",
    instituteName: "Phoenix College",
  },
];

const Resume = () => {
  return (
    <>
      <section id="resume" className="section">
        <div className="container">
          <div className="title">
            <h3>Experience</h3>
          </div>
          {/* End title */}
          <div className="resume-box">
            {resumeContent.map((val, i) => (
              <div className="resume-row" key={i}>
                <div className="row">
                  <div className="col-md-4 col-xl-3">
                    <div className="rb-left">
                      <h6>{val.jobPosition}</h6>
                      <label>{val.jobType}</label>
                      <p>{val.jobDuration}</p>
                      <div className="rb-time">{val.timeDuraton}</div>
                    </div>
                  </div>
                  <div className="col-md-8 col-xl-9">
                    <div className="rb-right">
                      <h6>{val.compnayName}</h6>
                      <p>{val.jobDescription}</p>
                    </div>
                  </div>
                </div>
              </div>
              // End resume-row
            ))}
          </div>

          {/* separated */}
          <div
            className="separated"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + "img/border-dark.png"
              })`,
            }}
          ></div>
          {/* End separated */}

          <div className="title">
            <h3>Education & Skills</h3>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-4 m-15px-tb">
              <ul className="aducation-box">
                {educatonContent.map((val, i) => (
                  <li key={i}>
                    <span>{val.passingYear}</span>
                    <h6>{val.degreeTitle} </h6>
                    <p>{val.instituteName}</p>
                  </li>
                ))}
              </ul>
            </div>
            {/* End .col */}

            <div className="col-lg-7 ml-auto m-15px-tb">
              <Skills />
            </div>
            {/* End .col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Resume;
